import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useLocalizeMessage, Table } from 'libs.nucleus';
import { stepResponseTypes } from '../../constants/step_response_type.constants';
import { substituteVariablesInEventListData } from '../../helpers/step_response_variable.helpers';
import { StepResponseValue } from '../visit_activity_responses/step_response_value.component';
import { getStepQuestion } from '../visit_activity_responses/visit_activity_responses.utils';
export const ResponseDetailView = ({ response }) => {
    const translate = useLocalizeMessage();
    // Filter out completion step responses and disabled steps
    const validStepResponses = (response?.c_step_responses?.data || [])
        .filter((stepResponse) => {
        return stepResponse.type !== stepResponseTypes.cCompletion.objectType && !stepResponse.c_step.c_disabled;
    })
        .sort((x, y) => x.c_step.c_order - y.c_step.c_order);
    // Prepare table data
    const tableData = validStepResponses.map((stepResponse) => {
        // Replace dynamic variables in the step question
        const metaVariables = response?.c_metadata || {};
        const processedStepResponse = { ...stepResponse };
        // Process dynamic variables if they exist
        if (metaVariables.variables) {
            const textStepKeys = ['c_description', 'c_question', 'c_text', 'c_text_choices'];
            for (const stepKey in processedStepResponse.c_step) {
                if (textStepKeys.includes(stepKey)) {
                    let stepValue = processedStepResponse.c_step[stepKey];
                    for (const variable in metaVariables.variables) {
                        const variableData = metaVariables.variables[variable];
                        if (variableData && !Array.isArray(variableData) && 'display' in variableData) {
                            if (Array.isArray(stepValue)) {
                                stepValue = stepValue.map((value) => {
                                    if (value.c_text && value.c_text.includes(`{${variable}}`)) {
                                        return {
                                            ...value,
                                            c_text: value.c_text.replace(new RegExp(`{${variable}}`, 'g'), variableData.display || ''),
                                        };
                                    }
                                    return value;
                                });
                            }
                            else if (typeof stepValue === 'string' && stepValue.includes(`{${variable}}`)) {
                                stepValue = stepValue.replace(new RegExp(`{${variable}}`, 'g'), variableData.display || '');
                            }
                        }
                    }
                    substituteVariablesInEventListData(metaVariables.variables);
                    processedStepResponse.c_step = {
                        ...processedStepResponse.c_step,
                        [stepKey]: stepValue,
                    };
                }
            }
        }
        return {
            id: stepResponse._id,
            question: getStepQuestion(processedStepResponse.c_step),
            response: _jsx(StepResponseValue, { stepResponse: processedStepResponse, variables: metaVariables.variables }),
        };
    });
    const columns = [
        {
            header: translate('generic.question'),
            accessorKey: 'question',
            cell: (context) => (_jsx("div", { className: 'text-sm text-gray-500', dangerouslySetInnerHTML: { __html: context.getValue() } })),
        },
        {
            header: translate('generic.responses', { count: 1 }),
            accessorKey: 'response',
            cell: (context) => {
                const value = context.getValue();
                return _jsx("div", { className: 'text-sm text-gray-900', children: React.isValidElement(value) ? value : String(value || '') });
            },
        },
    ];
    return (_jsxs("div", { className: 'flex flex-col gap-6', children: [_jsx("h3", { className: 'text-lg font-medium text-gray-900 mb-4', children: translate('generic.responses', { count: validStepResponses.length }) }), validStepResponses.length === 0 ? (_jsx("div", { className: 'text-center py-8 text-gray-500', children: _jsx("p", { children: translate('info.participant_responses.empty') }) })) : (_jsx(Table, { data: tableData, columns: columns, isLoading: false, labelNoResults: translate('info.participant_responses.filter_empty'), hasPagination: false }))] }));
};
